import React from 'react'
import {Link} from 'react-router-dom'
const ResetPassword = () => {
  return (
    <div className="min-h-full lg:bg-light-blue white-space-normal overflow-y-hidden">
    <div className=" bg-white lg:bg-light-blue  h-screen w-full grid place-items-center overflow-y-hidden pb-0  ">
    <div className="bg-white lg:shadow-lg rounded-lg w-full h-auto lg:w-96 p-6">
 {/* header */}
 <div className="flex flex-col justify-center items-center h-24 w-full ">
     <h1 className="font-poppins font-semi-bold text-2xl" >
     Reset password
     </h1>
     <div className="underline" />
 </div>
 {/* Form */}
 
   {/* Email */}
   <div className="flex flex-col   w-full mt-2  ">
      <label className="font-poppins font-medium text-base mb-2" >
      Email
      </label>
      <input className="bg-light-blue  text-base px-4 py-2 focus:outline-none  w-full" type="text" placeholder="Email" />
        </div>
        {/* Mail Instruction */}
        <div className="flex flex-col   w-full mt-2  ">
          <p className="font-poppins font-medium text-gray text-tiny mb-2" >
          You will receive an email with a unique token.
          </p>
          </div>
   
          {/* Submit */}
          <div className="flex flex-col bg-tradr-green  w-full mt-2  ">
            <Link to="/reset-sent" >
          <button className="btn-lg w-full  " type="submit" >
          RESET
          </button>
          </Link>
    </div>
    {/* FORGOT PASSWORD */}
    <div className="flex  w-full mt-4  items-center flex-col ">
    <Link to="/login" className="font-poppins font-medium text-gray text-tiny mb-2" >
    Back to Login
    </Link>
    
    </div>
    </div>
     </div>
     </div>
  )
}

export default ResetPassword